import React from 'react';
import { Typography } from 'antd';
import { getCountryName } from '../../utils';
import CircleFlag from '../../components/CircleFlag';
import numeral from 'numeral';

const { Text } = Typography;

export default function PlayerInfo(props) {
    const { challenger, matchData } = props;

    const challengerData =
        challenger === 'player'
            ? {
                  name: matchData.challenger1_name,
                  country: matchData.challenger1_country,
                  skill_level: matchData.challenger1_skill_level || matchData.challenger1_fargo,
                  tpa: calculateTPA('player'),
              }
            : {
                  name: matchData.challenger2_name,
                  country: matchData.challenger2_country,
                  skill_level: matchData.challenger2_skill_level || matchData.challenger2_fargo,
                  tpa: calculateTPA('opponent'),
              };

    // TPA formula = balls pocketed / balls pocketed + errors
    function calculateTPA(challenger) {
        let ballsPocketed;
        let errors;
        if (challenger === 'player') {
            ballsPocketed = matchData.challenger1_balls_pocketed;
            errors = matchData.challenger1_errors;
        } else {
            ballsPocketed = matchData.challenger2_balls_pocketed;
            errors = matchData.challenger2_errors;
        }

        const tpa = numeral(ballsPocketed / (ballsPocketed + errors)).format('0.000');
        // console.log({
        // 	ballsPocketed,
        // 	errors,
        // 	tpa
        // });
        return tpa;
    }

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                }}
            >
                {challengerData.country && <CircleFlag country={challengerData.country} left={0} />}

                <Text
                    style={{
                        fontSize: 25,
                        margin: 0,
                        fontWeight: 600,
                    }}
                >
                    {challengerData.name && challengerData.skill_level ? `${challengerData.name} (${challengerData.skill_level})` : challengerData.name}
                </Text>
            </div>
            <div>
                <Text style={{ fontSize: 25 }}>{challengerData.tpa} TPA</Text>
            </div>
        </div>
    );
}
